/**
 * Page loads out of this app (into another app, or to sign-in). Once one has started, guards must not start
 * another: e.g. signing out flips the session to "signed out", which would otherwise make the sign-in guard
 * send the person to /login?next=<this page> and the next person would land on it.
 */
let leaving = false;

export function isLeaving() {
  return leaving;
}

/** Full page load to a path another deployable owns. `replace` keeps Back working for redirects. */
export function leaveTo(path: string, opts: { replace?: boolean } = {}) {
  leaving = true;
  if (opts.replace) window.location.replace(path);
  else window.location.assign(path);
}

/** After the account backend has ended the one session (session.tsx signOut), leave for the sign-in page. */
export function signOutTo() {
  leaving = true;
  window.location.assign('/login');
}
